import { render } from "./PodftFilter.vue?vue&type=template&id=67c86b5e"
import script from "./PodftFilter.vue?vue&type=script&lang=js"
export * from "./PodftFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__